var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "staff-management-item" }, [
    _c("div", { staticClass: "staff-function" }, [
      _c("div", {}, [
        _c("div", { staticClass: "staff-title" }, [
          _c("div", { staticClass: "lead" }, [_vm._v(_vm._s(_vm.staffRole))]),
          _vm._v(" "),
          _c("div", { staticClass: "staff-filled" }, [
            _vm._v(
              _vm._s(_vm.getterGetStaffAssignList(_vm.staffRole).length) +
                "/" +
                _vm._s(_vm.maxValueStaff) +
                " staff filled"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "group-btn" }, [
        _c(
          "button",
          {
            staticClass: "ap-btn primary",
            on: {
              click: function($event) {
                _vm.addOrRemoveStaff(_vm.staffRole, true)
              }
            }
          },
          [_vm._v("Add")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "ap-btn destructive",
            attrs: {
              disabled:
                _vm.getterGetStaffAssignList(_vm.staffRole).length >=
                _vm.maxValueStaff
            },
            on: {
              click: function($event) {
                _vm.addOrRemoveStaff(_vm.staffRole, false)
              }
            }
          },
          [_vm._v("Remove")]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "staff-assign-slot" },
      _vm._l(_vm.maxValueStaff, function(slot, index) {
        return _c("div", { key: index, staticClass: "assign-slots" }, [
          _c(
            "button",
            {
              staticClass: "ap-btn compact",
              class: {
                secondary: _vm.getStaffAssignName(index) != "assign",
                tertiary: _vm.getStaffAssignName(index) == "assign",
                disabled:
                  index > _vm.getterGetStaffAssignList(_vm.staffRole).length
              },
              attrs: {
                disabled:
                  index > _vm.getterGetStaffAssignList(_vm.staffRole).length ||
                  _vm.isDisable,
                id: _vm.staffRole + "_" + index
              },
              on: {
                click: function($event) {
                  _vm.setOpenAssignModal(_vm.staffRole + "_" + index, index)
                }
              }
            },
            [_vm._v(_vm._s(_vm.getStaffAssignName(index)))]
          ),
          _vm._v(" "),
          _vm.getterOpenEventStaffModal == _vm.staffRole + "_" + index
            ? _c("div", { staticClass: "modal-staff-container" }, [
                _c("div", {
                  staticClass: "modal-staff-overlay",
                  on: {
                    click: function($event) {
                      _vm.setOpenAssignModal("")
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "modal-staff-content",
                    class: {
                      rightModal: _vm.isRightModal(_vm.staffRole + "_" + index)
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "icon-close",
                      on: {
                        click: function($event) {
                          _vm.setOpenAssignModal("")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-staff-title" }, [
                      _vm._v("assign staff")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-staff-search-box" },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.availableStaffList,
                            placeholder: "Find staff member",
                            label: "fullName",
                            openDirection: "below",
                            multiple: false,
                            "close-on-select": true,
                            "hide-selected": true,
                            "track-by": "id",
                            "allow-empty": true,
                            "show-labels": false
                          },
                          model: {
                            value: _vm.selectedStaff,
                            callback: function($$v) {
                              _vm.selectedStaff = $$v
                            },
                            expression: "selectedStaff"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-staff-btn-fnc" }, [
                      _c(
                        "div",
                        {
                          staticClass: "btn assign",
                          on: {
                            click: function($event) {
                              _vm.assignStaff(true)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "label" }, [
                            _vm._v("assign")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn unassign",
                          on: {
                            click: function($event) {
                              _vm.assignStaff(false)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "label" }, [
                            _vm._v("unassign")
                          ])
                        ]
                      )
                    ])
                  ]
                )
              ])
            : _vm._e()
        ])
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55e80233", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55e80233","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/eventDetail/StaffManagement.vue
// module id = 1625
// module chunks = 1